import { Component, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LANGS, LangCode, setLang, storedLang } from '../i18n';

// 紧凑语言切换器：地球图标 + 当前语言，点开下拉选 en/de/zh-TW。供登录等未进 layout 的页面用。
@Component({
  selector: 'app-lang-switch',
  templateUrl: './lang-switch.html',
})
export class LangSwitch {
  private translate = inject(TranslateService);

  langs = LANGS;
  current = signal<LangCode>(storedLang());
  open = signal(false);

  toggle(): void {
    this.open.set(!this.open());
  }

  pick(code: LangCode): void {
    setLang(this.translate, code);
    this.current.set(code);
    this.open.set(false);
  }

  currentLabel(): string {
    return LANGS.find((l) => l.code === this.current())?.label ?? 'English';
  }
}
